export default __webpack_public_path__ + "static/cybersecurity-90b509489cd7ac6d7d1963908ffe9c65.jpeg";